import {useNavigate, useSearchParams} from "react-router-dom";
import {useEffect, useState} from "react";
import Swal from "sweetalert2";
import {AuthService} from "./services/AuthService";

const ResetPassword = () => {
    const navigate = useNavigate();

    const [searchParams] = useSearchParams();

    const email = searchParams.get("email");
    const token = searchParams.get("token");

    const [form, setForm] = useState({
        newPassword: '', confirmPassword: ''
    });

    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleChange = (e) => {
        const {name, value} = e.target;
        setForm((prev) => ({
            ...prev, [name]: value
        }));
    };

    useEffect(() => {

        const isValidToken = async () => {
            try {
                await AuthService().isValidToken(email, token);
            } catch (e) {
                //console.error(e);
                await Swal.fire({
                    icon: "error", text: "Não foi possível validar o token para redefinir a senha!", title: ""
                });
                navigate('/forgotPassword');
            }
        };

        isValidToken();
    }, [email, token]);

    const handleResetPassword = async () => {
        try {
            const response = await AuthService().resetPassword(email, token, form.newPassword, form.confirmPassword);
            await Swal.fire({
                icon: "success",
                text: response.data.message,
                title: ""
            });
            navigate('/');
        } catch (e) {
            await Swal.fire({
                icon: "warning",
                text: e.response.data.message,
                title: ""
            });
        }
    };

    return (<div className={"flex items-center justify-center p-4 resetpassword-page"}>
            <div className="resetpassword-container bg-white w-full max-w-4xl">
                <div className="flex flex-col md:flex-row">
                    <div className="w-full md:w-1/2 p-8 flex flex-col">
                        <div className="flex items-center mb-8">
                            <div className="w-16 h-16 bg-blue-500 rounded-lg flex items-center justify-center mr-4">
                                <i className="fas fa-key text-white text-2xl"></i>
                            </div>
                            <h1 className="text-3xl font-bold text-gray-800">DDtank <span
                                className="text-blue-500">Splush</span></h1>
                        </div>

                        <div className="flex-1 flex items-center">
                            <div className="w-full">
                                <h2 className="text-2xl font-semibold text-gray-800 mb-6">Redefinir sua senha</h2>

                                <form id="resetForm" className="space-y-4">
                                    <div>
                                        <label htmlFor="newPassword"
                                               className="block text-sm font-medium text-gray-700 mb-1">Nova
                                            Senha</label>
                                        <div className="relative">
                                            <div
                                                className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <i className="fas fa-lock text-gray-400"></i>
                                            </div>
                                            <input type={`${showPassword ? "text" : "password"}`} id="newPassword" name={"newPassword"}
                                                   value={form.newPassword} onChange={handleChange}
                                                   className="resetpassword-input-field pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                                   placeholder="Digite sua nova senha" required/>
                                            <span className="resetpassword-password-toggle" id="toggleNewPassword">
                                        <i className={`${!showPassword ? "fa fa-eye" : "fas fa-eye-slash"}`} onClick={() => setShowPassword(!showPassword)}></i>
                                    </span>
                                        </div>
                                        {/*<div className="resetpassword-strength-meter">*/}
                                        {/*    <div className="resetpassword-strength-meter-fill"*/}
                                        {/*         id="passwordStrength"></div>*/}
                                        {/*</div>*/}
                                        {/*<p className="text-xs text-gray-500 mt-1">Mínimo de 8 caracteres, incluindo*/}
                                        {/*    números e símbolos</p>*/}
                                    </div>

                                    <div>
                                        <label htmlFor="confirmPassword"
                                               className="block text-sm font-medium text-gray-700 mb-1">Confirmar
                                            Senha</label>
                                        <div className="relative">
                                            <div
                                                className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                                <i className="fas fa-lock text-gray-400"></i>
                                            </div>
                                            <input type={`${showConfirmPassword ? "text" : "password"}`} id="confirmPassword" name={"confirmPassword"}
                                                   value={form.confirmPassword} onChange={handleChange}
                                                   className="resetpassword-input-field pl-10 w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500"
                                                   placeholder="Confirme sua nova senha" required/>
                                            <span className="resetpassword-password-toggle" id="toggleConfirmPassword">
                                         <i className={`${!showConfirmPassword ? "fa fa-eye" : "fas fa-eye-slash"}`}
                                            onClick={() => setShowConfirmPassword(!showConfirmPassword)}></i>
                                    </span>
                                        </div>
                                        <p id="passwordMatch" className="text-xs mt-1 hidden"></p>
                                    </div>

                                    {/*<div className="bg-gray-50 rounded-lg p-4">*/}
                                    {/*    <h4 className="text-sm font-medium text-gray-700 mb-2">Sua senha deve*/}
                                    {/*        conter:</h4>*/}
                                    {/*    <ul className="text-xs space-y-1 text-gray-600">*/}
                                    {/*        <li className="flex items-center" id="reqLength">*/}
                                    {/*            <i className="fas fa-circle text-xs mr-2 text-gray-400"></i>*/}
                                    {/*            <span>Mínimo 8 caracteres</span>*/}
                                    {/*        </li>*/}
                                    {/*        <li className="flex items-center" id="reqNumber">*/}
                                    {/*            <i className="fas fa-circle text-xs mr-2 text-gray-400"></i>*/}
                                    {/*            <span>Pelo menos 1 número</span>*/}
                                    {/*        </li>*/}
                                    {/*        <li className="flex items-center" id="reqSpecial">*/}
                                    {/*            <i className="fas fa-circle text-xs mr-2 text-gray-400"></i>*/}
                                    {/*            <span>Pelo menos 1 caractere especial</span>*/}
                                    {/*        </li>*/}
                                    {/*        <li className="flex items-center" id="reqUpper">*/}
                                    {/*            <i className="fas fa-circle text-xs mr-2 text-gray-400"></i>*/}
                                    {/*            <span>Pelo menos 1 letra maiúscula</span>*/}
                                    {/*        </li>*/}
                                    {/*    </ul>*/}
                                    {/*</div>*/}

                                    <button type="button" onClick={() => handleResetPassword()}
                                            className="resetpassword-btn-login w-full py-3 px-4 text-white font-medium rounded-lg">
                                        <i className="fas fa-key mr-2"></i> Redefinir Senha
                                    </button>

                                    <div className="text-center pt-4">
                                        <a href="#"
                                           className="text-blue-500 hover:text-blue-700 text-sm flex items-center justify-center">
                                            <i className="fas fa-arrow-left mr-2"></i> Voltar para o login
                                        </a>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="w-full md:w-1/2 bg-gray-50 p-8 flex flex-col">
                        <div className="mb-8">
                            <div className="flex items-center mb-4">
                                <i className="fas fa-shield-alt text-blue-500 mr-2"></i>
                                <h3 className="text-xl font-semibold text-gray-800">Segurança da Conta</h3>
                            </div>

                            <div className="bg-white p-4 rounded-lg shadow-sm">
                                <div className="flex items-start mb-4">
                                    <div className="bg-blue-100 text-blue-500 p-2 rounded-full mr-3">
                                        <i className="fas fa-info-circle"></i>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Dicas para uma senha segura</h4>
                                        <p className="text-sm text-gray-600 mt-1">Use uma combinação de letras, números
                                            e símbolos. Evite informações pessoais como datas de nascimento.</p>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="bg-green-100 text-green-500 p-2 rounded-full mr-3">
                                        <i className="fas fa-check-circle"></i>
                                    </div>
                                    <div>
                                        <h4 className="font-medium text-gray-800">Senha atualizada</h4>
                                        <p className="text-sm text-gray-600 mt-1">Após redefinir, você será desconectado
                                            de todos os dispositivos por segurança.</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="flex-1">
                            <div className="flex items-center mb-4">
                                <i className="fas fa-question-circle text-blue-500 mr-2"></i>
                                <h3 className="text-xl font-semibold text-gray-800">Precisa de ajuda?</h3>
                            </div>

                            <div className="bg-white p-4 rounded-lg shadow-sm">
                                <div className="space-y-3">
                                    <div>
                                        <h4 className="font-medium text-gray-800">Suporte por e-mail</h4>
                                        <p className="text-sm text-gray-600 mt-1">Envie um e-mail para <a
                                            href={`mailto:${process.env.REACT_APP_HELP_EMAIL}`}
                                            className="text-blue-500">{process.env.REACT_APP_HELP_EMAIL}</a></p>
                                    </div>

                                    <div>
                                        <h4 className="font-medium text-gray-800">Discord oficial</h4>
                                        <p className="text-sm text-gray-600 mt-1">Junte-se ao nosso <a
                                            href={process.env.REACT_APP_DISCORD_URLA}
                                            className="text-blue-500">servidor
                                            no Discord</a> para suporte imediato.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="bg-gray-800 text-white px-6 py-4 text-center text-sm">
                    <p>DDtank Splush © 2025 - Todos os direitos reservados</p>
                    <div className="flex justify-center space-x-4 mt-2">
                        <a href="#" className="hover:text-blue-300"><i className="fab fa-facebook"></i></a>
                        <a href="#" className="hover:text-blue-400"><i className="fab fa-twitter"></i></a>
                        <a href="#" className="hover:text-red-400"><i className="fab fa-youtube"></i></a>
                        <a href="#" className="hover:text-purple-400"><i className="fab fa-discord"></i></a>
                    </div>
                </div>
            </div>
        </div>);
};

export default ResetPassword;